import { gql } from '@apollo/client';

export const GET_PAGE_QUERY = gql`
    query GetPage($id: ID!) {
        Page(id: $id) {
            content {
                ... on FeaturedAd {
                    title
                    subtitle
                    cta
                    url
                    image {
                        altText
                        asset {
                            _id
                            url
                        }
                        hotspot {
                            x
                            y
                            height
                            width
                        }
                        crop {
                            top
                            bottom
                            left
                            right
                        }
                    }
                    publishedAt
                }
            }
        }
    }
`;
